import { validatePdfFormatFile } from '../helpers/validation';

export const useOnDrop = (callback) => {
    const onDrop = (e) => {
        if (validatePdfFormatFile(e.dataTransfer.files[0])) {
            callback(e.dataTransfer.files[0]);
        }
    };
    const onSelectFile = () => {
        if (validatePdfFormatFile(document.querySelector('.dropzoneFile').files[0])) {
            callback(document.querySelector('.dropzoneFile').files[0]);
        }
    };

    return { onDrop, onSelectFile };
};
